import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/designsystemet.css';
import './styles/fonts.css';
import './styles/trustpulse-theme.css';
import './index.css';
import './i18n/config';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ServiceContextProvider } from './contexts/ServicesContext.tsx';
import { FeatureFlagProvider } from './contexts/FeatureFlagContext.tsx';
import { ToastContainer } from 'react-toastify';
import { routesWithOptions } from './contexts/routerMetaDataContext.tsx';
import { init, feedbackIntegration, replayIntegration } from '@sentry/react';
import * as queries from './api/queries.ts';
import * as workEnvironmentQueries from './api/workEnvironmentQueries.ts';
import * as tenantFeatures from './api/tenantFeatures.ts';

const router = createBrowserRouter(routesWithOptions);

const shouldActivateSentry: boolean =
  window.location.hostname === 'app.trustpulse.no';

init({
  dsn: shouldActivateSentry
    ? 'https://25c73815ffc038825f077c0bc7443248@o4509023265030144.ingest.de.sentry.io/4509023278858320'
    : '',
  integrations: [feedbackIntegration(), replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const allQueries = {
  ...queries,
  ...workEnvironmentQueries,
  ...tenantFeatures,
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ServiceContextProvider {...allQueries}>
      <FeatureFlagProvider>
        <RouterProvider router={router} />
        <ToastContainer />
      </FeatureFlagProvider>
    </ServiceContextProvider>
  </StrictMode>,
);
